export class LinkUtils {
  /**
   * Check the URL format return true if begins by 'http'
   */
  static isHttpUrlLink(url: string) {
    if (url) {
      return url.startsWith('http') || url.startsWith('www');
    } else {
      return false;
    }
  }

  static resolveUrlLink(url: string) {
    return url?.replace(/\/+/g, '/').replace(/\/$/, '');
  }
}
